import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/events/[slug]/sponsor/_components/ApplyToSponsorEventFlow.tsx");
